
import { getAuthData } from '../../Utils/AuthUtils';
import { useState } from 'react';

export default function WelcomeFirstInquiry({ 
  isOpen, 
  onStart,
  onClose
}) {
  const authData = getAuthData();
  const userName = authData.UserName;

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full">
            {/* Content */}
            <div className="text-center pt-4 pb-6 px-8">
              <div className="flex justify-center m-8">
                <div className="relative">
                  <div className="w-20 h-20 bg-sahi-green rounded-full flex items-center justify-center animate-pulse">
                    <div className="w-20 h-20 bg-sahi-green rounded-full flex items-center justify-center shadow-lg">
                      <svg 
                        className="w-10 h-10 text-white animate-bounce" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path 
                          strokeLinecap="round" 
                          strokeLinejoin="round" 
                          strokeWidth={3} 
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  </div>
                  {/* Success particles animation */}
                  <div className="absolute -top-2 -left-2 w-2 h-2 bg-yellow-400 rounded-full animate-ping"></div>
                  <div className="absolute -top-1 -right-3 w-1.5 h-1.5 bg-yellow-300 rounded-full animate-ping" style={{animationDelay: '0.2s'}}></div>
                  <div className="absolute -bottom-2 -right-1 w-2 h-2 bg-yellow-400 rounded-full animate-ping" style={{animationDelay: '0.4s'}}></div>
                  <div className="absolute -bottom-1 -left-3 w-1.5 h-1.5 bg-yellow-300 rounded-full animate-ping" style={{animationDelay: '0.6s'}}></div>
                </div>
              </div>
              {/* Header */}
              {/* <div className="text-sahi-grey text-center justify-between">
                <h2 className="text-xl">Welcome{userName !== '' ? `, ${userName}` : ''}</h2>
              </div> */}
              <h1 className="text-3xl font-bold text-sahi-green mb-4 animate-fade-in">
                Congratulations!
              </h1>
              <p className="text-base text-sahi-grey px-4 animate-fade-in" style={{animationDelay: '0.3s'}}>
                You've added your first inquiry and contact!<br /><br />
                <span className='text-sahi-grey'>Let's explore the key features of our CRM to help you manage your business effectively.</span>
              </p>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.6s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </>
  );
}